<template lang="pug">
v-layout(row justify-center align-center v-if="isFormDataLoading")
  v-card.opt-in-form-card.px-4.py-3
    v-card-title(class='d-flex flex-column align-center')
      .skeleton-loader
    v-card-text
      v-layout(column)
        v-layout(wrap)
          v-flex(xs12)
            .skeleton-loader
            .skeleton-loader
          v-flex(xs12)
            .skeleton-loader-box
          v-flex(xs12)
            .skeleton-loader
v-layout(row justify-center align-center v-else)
  v-card.opt-in-form-card.px-4.py-3
    v-card-title(class='d-flex flex-column align-center').text-center
      h2.subtitle-section(theme--light) SMS Opt-in Form
    v-card-text
      v-layout(column v-if="isSuccess")
        v-flex(xs12).text-center
          v-icon.success-icon task_alt
          h3(theme--light) Success!
          p.mt-3.subtitle-section.theme--light.v-messages Thank you for signing up for text messages. You have successfully subscribed to receive marketing text messages, including promotions, reminders, and industry news from {{ this.formData.business_name }}. You have also agreed to our 
            a(href="this.formData.privacy_policy_url" target="_blank") {{ this.formData.privacy_policy_text }}
            | .
      v-layout(column v-else)
        v-form(
          ref="form"
          v-model="valid"
        )
          v-layout(wrap)
            v-flex(xs12)
              v-text-field(
                label="Phone*"
                v-model="contact.phone"
                :rules="[rules.phone]"
                required
              )
              v-text-field(
                label="First Name*"
                v-model="contact.firstName"
                :rules="[rules.required]"
                required
              )
          v-layout(wrap)
            v-flex(xs12 v-if="hasErrorMessage").pt-3
              p.subtitle-section.error-message.v-messages - {{ errorMessage }}
            v-flex(xs12)
              v-checkbox(
                color="primary"
                :rules="[rules.requiredNoMsg]"
              ).mt-1.pt-0.form-checkbox
                template(slot="label")
                  p.subtitle-section.theme--light.v-messages.mb-0(v-html="description")
            v-flex(xs12).text-center
              v-btn(
                color='primary'
                @click="submit"
                :loading="isLoading"
              ).submit-btn.ma-0 Submit
</template>
<script>
import {
  PHONE_WITHOUT_COUNTRY_REGEX,
} from "@/Core/config/regex";

import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: 'OptInForm',
  data() {
    return {
      valid: false,
      contact: {
        firstName: '',
        phone: '',
      },
      rules: {
        required: value => !!value || 'This field is required.',
        requiredNoMsg: value => !!value || '',
        phone: value => {
          return PHONE_WITHOUT_COUNTRY_REGEX.test(value) || 'Invalid phone number';
        },
      },
    };
  },
  computed: {
    ...mapState('optInForm', [
      'isLoading',
      'isSuccess',
      'isFormDataLoading',
      'errorMessage',
      'description',
      'formData',
    ]),
    ...mapGetters('optInForm', [
      'hasErrorMessage',
    ]),
  },
  methods: {
    ...mapActions('optInForm', [
      'submitOptInForm',
      'getData',
    ]),
    submit() {
      if (this.$refs.form.validate()) {
        const payload = {
          ...this.contact,
          description: this.description.replace(/<\/?[^>]+(>|$)/g, ''),
          url: window.location.href,
          token: this.$route.query.t || '',
        };
        this.submitOptInForm(payload);
      }
    },
  },
  mounted() {
    this.contact.firstName = this.$route.query.firstName || '';
    this.contact.phone = this.$route.query.phone || '';
    this.getData(this.$route.query.t || '');
  },
}
</script>
<style lang="scss">
.opt-in-form-card {
  width: 500px;

  a {
    font-weight: bold;
  }
  .logo {
    max-width: 200px;
  }
  .text-center{
    text-align: center;
  }
  .success-icon {
    color: var(--v-success-base) !important;
    font-size: 80px;
  }
  .error-message {
    color: var(--v-error-base) !important;
  }
  .form-checkbox{
    .v-input__slot{
      align-items: flex-start;
    }
  }
  .submit-btn {
    width: 100%;
  }
  .skeleton-loader {
    background: url("/static/img/cell-skeleton-loader.svg"), repeating-linear-gradient(#fdfdfd, #fdfdfd 47px, #dddddd 48px);
    background-size: 100% 48px, auto;
    height: 47px;
  }
  .skeleton-loader-box {
    background: url("/static/img/cell-skeleton-loader.svg"), repeating-linear-gradient(#fdfdfd, #fdfdfd 80px, #dddddd 81px);
    background-size: 100% 81px, auto;
    height: 80px;
  }
}
</style>
